<template>
  <div style="display: inline-flex;"> 
  <el-popover placement="bottom-start" title="" width="300" trigger="click">
    <template #reference>
      <div class="fast-table__head__th__search__col"  >
        <el-icon :color="state.sureText?'val(--el-color-primary)':undefined" >
          <Search />
        </el-icon>
        <div v-if="state.sureText" class="fast-table__head__th__search__col_text">{{state.sureText}}</div>
      </div>
    </template>
    <div>
      <el-input type="textarea" v-model="state.inputText" style="width: 240px" placeholder="請輸入" />
      <el-button @click="submitData"  style="width: 240px;margin-top:20px;" type="primary">確定</el-button>
    </div>
   
  </el-popover>
 
</div>
</template>

<script lang="ts" setup>

import { trim } from "lodash-es";
import {  Search } from "@element-plus/icons-vue";
import { ref, reactive, onMounted, watch } from "vue";
import type { Ref } from "vue";
const emit = defineEmits()

const props = defineProps({
  //表格选择的数据
  modelValue: {
    type: String,
    default:"",
  },
   
   
 
})
let state: any = reactive({
  inputText: "",
  sureText:props.modelValue
});
watch(()=>props.modelValue,(v)=>{
  state.inputText=v;
  state.sureText=v;
})
function submitData(){
  state.sureText=state.inputText.split(/[\n\s,，;]/).map(o=>trim(o)).filter(o=>!!o).join("\n")
  state.inputText=state.sureText
  emit('change',state.sureText)
}
</script>

<style scoped>
.fast-table__head__th__search__col{
  display: flex;
  align-items: center;
  cursor: pointer;
}
.fast-table__head__th__search__col_text{
  width: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
